import React from 'react';

import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';
import styled from 'styled-components';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

import { getSelectedCioFacetRbid } from '../../utils/filters';

const DynamicFormattedMessage = FormattedMessage;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

const CheckboxBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
`;

const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 20px;
  height: 20px;
  background-color: white;
  cursor: pointer;
  ${({ theme }) => theme.gridFilterStyles.inputStyle};

  &:checked {
    border-color: ${({ theme }) =>
      theme.colors.gridSelectedFilterBackgroundColor};
    background-color: ${({ theme }) =>
      theme.colors.gridSelectedFilterBackgroundColor};
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme }) => theme.colors.gridSwatchInputCheckedFocus};
    outline-offset: 2px;
  }
`;

const CheckIcon = styled(FaCheck)`
  pointer-events: none;
  position: absolute;
  inset: 0;
  margin: auto;
  color: white;
  font-size: 10px;
  opacity: 0;
  transition: opacity 0.2s;

  ${StyledCheckbox}:checked + & {
    opacity: 1;
  }
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 400;
  color: black;
  line-height: 1;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.gridFilterStyles.listingFilterStyle};
`;

function Checkbox({ id, name, label, checked, onChange, filterName }) {
  return (
    <CheckboxWrapper data-autotag={`filter-${filterName}-option`}>
      <CheckboxBox>
        <StyledCheckbox
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
        />
        <CheckIcon aria-hidden="true" />
      </CheckboxBox>
      <Label htmlFor={id}>
        <DynamicFormattedMessage
          id={`site_product_filter.${getSelectedCioFacetRbid(
            filterName,
            name
          )}`}
          defaultMessage={label}
        />
      </Label>
    </CheckboxWrapper>
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  filterName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Checkbox;
